import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';
// PrimeReact required CSS
import "primereact/resources/themes/lara-light-indigo/theme.css"; // choose any theme
import "primereact/resources/primereact.min.css"; // core css
import "primeicons/primeicons.css"; // icons
import "quill/dist/quill.snow.css";

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


import { Toaster } from "react-hot-toast";
import AOS from "aos";

import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap classes
import "aos/dist/aos.css"; // AOS CSS
import "./index.css"; // Global custom CSS

import App from "./App";
import store from "./redux/store";

// Initialize AOS animations globally
AOS.init({
  duration: 800, // Animation duration
  offset: 100, // Trigger point on scroll
  easing: "ease-in-out", // Smooth effect
  once: true, // Animate only once
});

// Render App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <Provider store={store}>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontSize: "14px",
              borderRadius: "8px",
            },
          }}
        />
        <App />
      </BrowserRouter>
    </Provider>

);
